import { render, staticRenderFns } from "./ForeignReport.vue?vue&type=template&id=349db595"
import script from "./ForeignReport.vue?vue&type=script&lang=js"
export * from "./ForeignReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports